import { Checkbox as UICheckbox } from '@/components/ui';

import { useFieldContext } from './contexts';

type Props = {
  label: string;
  disabled?: boolean;
};

export function Checkbox({ label, disabled }: Props) {
  const field = useFieldContext<boolean>();

  return (
    <UICheckbox
      label={label}
      checked={field.state.value ?? false}
      disabled={disabled}
      onChange={(checked) => field.handleChange(checked)}
    />
  );
}
